import { IBooksDetailData } from 'constants/types';
import { BooksType } from 'components/Books/card/BooksCardTypes';

export enum BooksCardBigThemeType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
export interface IBooksCardBigProps {
  item: IBooksDetailData
  themeType?: BooksCardBigThemeType
  priorityPreview?: BooksType
}
